import { useSelector } from 'react-redux';

// The `/credit-accounts` endpoint is used to source the JE Credit Account column
// only when this accounting company setting is enabled; otherwise expense
// categories are used as the fallback source.
export const useCreditAccountEndpointEnabled = () =>
  useSelector(state => state.accounting?.companySettings?.use_credit_account_endpoint === true);
